import emailAsync from '@/api/mail';
import { TYPE_EDITION_ORDRE_TRAVAIL_MAIL } from '@/configuration/logistique/ordreTravail/ordreTravailConf';

async function envoieMailOtTech(mail, mettreEdition, societeId, otId) {
  const params = {
    mettreEdition: mettreEdition,
    typeDonnee: TYPE_EDITION_ORDRE_TRAVAIL_MAIL,
    elementId: otId,
    societeId: societeId,
  };
  const data = new FormData();
  data.append('mailRequest', JSON.stringify(mail));
  if (mail.piecesJointes) {
    mail.piecesJointes.forEach((file) => {
      data.append(file.name, file, file.name);
    });
  }
  await emailAsync(params, data);
}

export default envoieMailOtTech;
